import { EmailUpdatesScreen } from '@/screens/name-screen/EmailUpdatesScreen'

export default function () {
  return <EmailUpdatesScreen />
}
